module.exports = __webpack_public_path__ + "assets/img/25-s.5b7172c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/25-s.jpg
// module id = f4Qe
// module chunks = 0